import Api from 'services/Api';
import ParserRestApi from 'helpers/ParserRestApi';

const fetchOnce = (id, reducer, url, callback, defaultValues = false) => {
	return (dispatch) => {
		if (ParserRestApi.isIdCreate(id)) {
			let props = {id: false};
			if (defaultValues !== false) {
				props = {
					...props,
					...defaultValues
				}
			}
			dispatch({
				type: reducer.GET_ONCE,
				payload: {
					props
				}
			});
			return typeof callback === 'function' ? callback() : false;
		}
		dispatch({
			type: reducer.FETCHING_ONCE,
		});
		Api.get(
			{},
			url + '/' + id,
			(error, data) => {
				if (error) {
					return dispatch({
						type: reducer.ERROR_ONCE,
						payload: {
							message: error,
						},
					});
				}

				return dispatch({
					type: reducer.GET_ONCE,
					payload: {
						props: data
					}
				});
			}
		);
	};
};
export default fetchOnce;
